module.exports = __webpack_public_path__ + "static/media/turtle.d2d1b55f.png";